export default (api) => {
  return
  api.user.admin.read = (target) => {
    console.warn('api.user.admin.read', target)
    return api.mockHelper.success(api.mockHelper.models.user.item())
  }

  api.user.admin.index = (params) => {
    console.warn('api.user.admin.index', params)
    const indexData = api.mockHelper.models.user.index(params)
    return api.mockHelper.success(indexData)
  }

  api.user.admin.update = (target, params) => {
    console.warn('api.user.admin.update', target, params)
    return api.mockHelper.success(api.mockHelper.models.user.item())
  }

  api.user.admin.batch = (params) => {
    console.warn('api.user.admin.batch', params)
    return api.mockHelper.success()
  }

  api.user.admin.roles = () => {
    return api.mockHelper.success([
      'ROLE_ADMIN',
    ])
  }

  api.user.admin.delete = (id) => {
    console.warn('api.user.admin.delete', id)
    return api.mockHelper.success()
  }

  api.user.admin.batchDelete = (params) => {
    console.warn('api.user.admin.batchDelete', params)
    return api.mockHelper.success()
  }
}